import gameData from "../../gameData.js";
import TrayBaseColors from './trayBaseColors.js';
import trayMini from "./trayMini.js";

export default class PaintTray extends TrayBaseColors
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.isActive = false;

        this.createDotTray();
        this.createMiniTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createDotTray()
    {
       for(let i=0;i<13;i++){
            let dot = this.scene.addButton(0, 0, "dot", null, ()=>{
                this.scene.playSound("select_color_pattern_face");

                gameData.paintColor = dot.tintColor;
                this.miniTray.setBtnTint(dot.tintColor);
                this.scene.faceMask.setPaintColor();
                
                this.tweenInCursor(dot.tintColor);
            }, this);

            dot.tintColor = gameData.dotColors[i];
            dot.tint = gameData.dotColors[i];
            dot.x = i%2 ? 30 : 85;
            dot.y = -300 + (50*i);

            this.dots.push(dot);
        }
    }

    createMiniTray()
    {
        this.miniTray = new trayMini(this.scene, this, "size");
    }

    cleanUp()
    {
        this.cursor.destroy();
        this.dots.forEach(dot => {dot.destroy();});
        this.nameplate.destroy();
        this.nameplateText.destroy();

        if(this.miniTray){
            this.miniTray.cleanUp();
            this.miniTray.destroy();
        }
    }
}